import { useResizeWindow } from '@/lib/hooks/use-resize-window'

export const useSelectOtherCasesButton = () => {
  const { width: windowWidth } = useResizeWindow()

  return {
    windowWidth,
  }
}
